const DOCX_CONTENT_TYPES_PATH = '[Content_Types].xml';
const DOCX_DOCUMENT_XML_PATH = 'word/document.xml';
const DOCX_EXTENSION_RE = /\.docx$/i;

export async function ensureReadableDocxPackageBuffer(buffer: ArrayBuffer): Promise<ArrayBuffer> {
  if (await isReadableDocxPackageBuffer(buffer)) return buffer;

  const nestedBuffer = await extractSingleNestedDocxBuffer(buffer);
  if (nestedBuffer && await isReadableDocxPackageBuffer(nestedBuffer)) {
    return nestedBuffer;
  }

  throw new Error('Draft editor export was not a readable DOCX package.');
}

export async function readDocxArrayBufferFromBlob(blob: Blob): Promise<ArrayBuffer> {
  return ensureReadableDocxPackageBuffer(await blob.arrayBuffer());
}

async function isReadableDocxPackageBuffer(buffer: ArrayBuffer): Promise<boolean> {
  try {
    const { default: JSZip } = await import('jszip');
    const zip = await JSZip.loadAsync(buffer.slice(0));
    return Boolean(
      zip.file(DOCX_CONTENT_TYPES_PATH)
      && zip.file(DOCX_DOCUMENT_XML_PATH),
    );
  } catch {
    return false;
  }
}

async function extractSingleNestedDocxBuffer(buffer: ArrayBuffer): Promise<ArrayBuffer | null> {
  try {
    const { default: JSZip } = await import('jszip');
    const zip = await JSZip.loadAsync(buffer.slice(0));
    const nestedDocxFiles = Object.values(zip.files).filter((entry) => (
      !entry.dir && DOCX_EXTENSION_RE.test(entry.name)
    ));
    if (nestedDocxFiles.length !== 1) return null;
    return await nestedDocxFiles[0].async('arraybuffer');
  } catch {
    return null;
  }
}
